import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

import CheckOutlinedIcon from './icons/other/CheckOutlinedIcon.vue';
import CloseOutlinedIcon from './icons/other/CloseOutlinedIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VReferalSuccessLabel',
  props: {
    status: null,
    count: null
  },
  setup(__props: any) {

const props = __props as { status: string, count: number }




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["auth__success-label", { hidden: props.status === 'none', error: __props.status.startsWith('error') }])
  }, [
    _createElementVNode("div", null, [
      (props.status.startsWith('error'))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(CloseOutlinedIcon),
            (props.status === 'error-already-use')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("This code already use")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("This code either expired or doesn't exist!")
                ], 64))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(CheckOutlinedIcon),
            _createTextVNode(" Code was applied successfully! " + _toDisplayString(props.count) + " FREE actions added to your account ", 1)
          ], 64))
    ])
  ], 2))
}
}

})